import { Move, isDirectAttackMove, isDoublePowerMove, isElectroBallMove, isGyroBallMove, isHadouMove, isHakidasuMove, isHatakiotosuMove, isHeavySlamMove, isHundonokobushiMove, isHydroSteamMove, isKamitukiMove, isKaragenkiMove, isKataYaburiMove, isKetaguriMove, isKiruMove, isKishikaiseiMove, isMagnitudeMove, isMultiAttackMove, isOhakamairiMove, isOtoMove, isPhotonGeyserMove, isPhysicalMove, isPsyBladeMove, isPunchMove, isRevelationDanceMove, isRisingBoltMove, isSpecialMove, isStoredPowerMove, isSutemiWazaMove, isTechnoBlastMove, isTerabrastMove, isTerasPowerUpMove, isTikarazukuTargetMove, isTripleKickAcceleratorMove, isWavesOfTheEarthMove, isWeatherBallMove, isWideForceMove, isWringOutMove, isZishinMove } from "../../move/move";
import {
  OFFENCE_ITEM_ID_PUNCHGLOVE,
  OFFENCE_ITEM_ID_TIKARANOHACHIMAKI,
  OFFENCE_ITEM_ID_MONOSHIRIMEGANE,
  OFFENCE_ITEM_ID_NORMAL_JEWEL,
  OFFENCE_ITEM_ID_SHIRATAMA,
  OFFENCE_ITEM_ID_KONGOUDAMA,
  OFFENCE_ITEM_ID_HAKKINDAMA,
  OFFENCE_ITEM_ID_KOKORONOSHIZUKU,
  OFFENCE_ITEM_ID_DAIKONGOUDAMA,
  OFFENCE_ITEM_ID_DAISHIRATAMA,
  OFFENCE_ITEM_ID_DAIHAKKINDAMA,
  POKEMON_ITEM_ID_NO_SET as DEFENCE_ITEM_ID_NO_SET,
} from "../../types/item";
import { isPlateItem, getPlateType } from "../../pokemon/PlateUtils";
import { ARCEUS_SPECIES_ID } from "../../pokemon/arceus";
import {
  BATTLE_FIELD_EREKI,
  BATTLE_FIELD_PSYCHO_SAIKO,
  BATTLE_FIELD_MISUTO,
  BATTLE_FIELD_GLASS,
  WEATHER_SUNA,
  WEATHER_HARE,
  WEATHER_OOHIDERI,
  WEATHER_AME,
  WEATHER_OOAME,
  WEATHER_YUKI,
} from "../../types/other-setting";
import type { otherSetting } from "../../types/other-setting";
import type { PokemonV2 } from "../../types/pokemon";
import {
  POKEMON_TYPE_NORMAL,
  POKEMON_TYPE_FLYING,
  POKEMON_TYPE_ELECTRIC,
  POKEMON_TYPE_ICE,
  POKEMON_TYPE_ROCK,
  POKEMON_TYPE_GROUND,
  POKEMON_TYPE_STEEL,
  POKEMON_TYPE_PSYCHIC,
  POKEMON_TYPE_GRASS,
  POKEMON_TYPE_DRAGON,
  POKEMON_TYPE_WATER,
  POKEMON_TYPE_GHOST,
} from "../../types/type";
import { isNotGrounded } from "../pokemon/battle-state";
import { hasPokemonStatus, isBurnedStatus, isJuudenStatus, isPoisonedStatus } from "../pokemon/status";
import { hasWeatherBlockAbility, isAnalyze, isDokubousou, isErekiSkin, isFailySkin, isFreezeSkin, isGanzixyouago, isKataitume, isKireazi, isMegaLauncher, isNetubousou, isNormalSkin, isPunkRock, isSkySkin, isSunanotikara, isSutemi, isTechnician, isTennen, isTetunokobushi, isTikarazuku } from "../ability";
import { per_120, per_150, per_200, per_130, per_130_normal_jewel_field, per_110_punchglobe, per_110, per_050 } from "./constants";
import { calc_五捨五超入_gosutegoire, calcRankedValue } from "./core-utils";
import { resolveRevelationDanceMoveType } from "../revelation-dance";
import { resolveTechnoBlastMoveType } from "../techno-blast";
import { resolveMultiAttackMoveType } from "../multi-attack";
import { calcEffectiveSpeedForPowerMoves, type PowerMoveSpeedModifiers } from "../stat/effective-speed";
// 【1】威力の補正値
export function calc_move_power({
  move,
  offencePokemon,
  deffencePokemon,
  // rateMapper,
  loopHitNumber,
  otherSetting,
}: {
  move: Move;
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
  // rateMapper: damageRateMapper;
  loopHitNumber: number;
  otherSetting: otherSetting;
}) {
  // 技タイプ変更の影響を反映するため、コピーした技データで処理する
  let effectiveMove = { ...move };
  const normalizedSpeciesId =
    offencePokemon.species_id != null ? Number(offencePokemon.species_id) : undefined;
  const isArceus = normalizedSpeciesId === ARCEUS_SPECIES_ID || offencePokemon.id === ARCEUS_SPECIES_ID;
  
  if (effectiveMove.id === 449 && isArceus) {
    const plateType = getPlateType(offencePokemon.selected_item_id);
    if (plateType !== null) {
      effectiveMove = { ...effectiveMove, type: plateType };
    }
  }

  // めざめるダンスは使用者のタイプ（タイプ1/テラスタル）で攻撃する
  if (isRevelationDanceMove(move)) {
    effectiveMove = {
      ...effectiveMove,
      type: resolveRevelationDanceMoveType(offencePokemon),
    };
  }

  // テクノバスターはカセットに応じてタイプが変化する
  if (isTechnoBlastMove(move)) {
    const technoBlastType = resolveTechnoBlastMoveType(offencePokemon);
    if (technoBlastType) {
      effectiveMove = { ...effectiveMove, type: technoBlastType };
    }
  }

  // マルチアタックはメモリに応じてタイプが変化する
  if (isMultiAttackMove(move)) {
    const multiAttackType = resolveMultiAttackMoveType(offencePokemon);
    if (multiAttackType) {
      effectiveMove = { ...effectiveMove, type: multiAttackType };
    }
  }

  // ノーマルスキンは使用する技を全てノーマルタイプにする（元がノーマル以外の場合は威力補正対象）
  const normalSkinConverted = isNormalSkin(offencePokemon) && effectiveMove.type !== POKEMON_TYPE_NORMAL;
  if (isNormalSkin(offencePokemon)) {
    effectiveMove = { ...effectiveMove, type: POKEMON_TYPE_NORMAL };
  }
  
  // 基本威力（この後の条件で書き換え）
  let power = effectiveMove.power;
  const isKatayaburiMove = isKataYaburiMove(move);
  const isPhotonGeyser = isPhotonGeyserMove(move);
  const photonGeyserAttackRank = (isTennen(deffencePokemon) && !isKatayaburiMove)
    ? 0
    : (offencePokemon.rankCorrection?.attack ?? 0);
  const photonGeyserSpecialAttackRank = (isTennen(deffencePokemon) && !isKatayaburiMove)
    ? 0
    : (offencePokemon.rankCorrection?.special_attack ?? 0);
  const photonGeyserUsesAttack =
    isPhotonGeyser &&
    calcRankedValue(offencePokemon.effective_value.attack, photonGeyserAttackRank) >
    calcRankedValue(offencePokemon.effective_value.special_attack, photonGeyserSpecialAttackRank);
  const photonGeyserUsesSpecial = isPhotonGeyser && !photonGeyserUsesAttack;
  // 威力補正で物理/特殊判定を揃えるために保持する
  
  // ザシアン(けんのおう)・ザマゼンタ(たてのおう)のアイアンヘッド → きょじゅうざん・きょじゅうだん (威力100)
  if ((offencePokemon.id === 10188 || offencePokemon.id === 10189) && move.id === 442) {
    power = 100;
  }

  // きしかいせい/じたばたは基礎威力が可変（マスターデータはnull）。UI側の custom_power を優先し、未指定なら20を採用する。
  if (isKishikaiseiMove(move)) {
    if (offencePokemon.other_setting.custom_power) {
      power = offencePokemon.other_setting.custom_power;
    } else if (power == null) {
      power = 20;
    }
  }

  // マグニチュードは基礎威力が可変（マスターデータはnull）。UI側の custom_power を優先し、未指定なら10を採用する。
  if (isMagnitudeMove(move)) {
    if (offencePokemon.other_setting.custom_power) {
      power = offencePokemon.other_setting.custom_power;
    } else if (power == null) {
      power = 10;
    }
  }

  // ジャイロボールは判定用Sで威力が変動する
  if (isGyroBallMove(move)) {
    power = calcPowerGyroBall({ offencePokemon, deffencePokemon, otherSetting });
  }

  // エレキボールは判定用Sの比で威力が変動する
  if (isElectroBallMove(move)) {
    power = calcPowerElectroBall({ offencePokemon, deffencePokemon, otherSetting });
  }
  
  if (isKetaguriMove(move)) {
    power = calcPowerKetaguri(deffencePokemon);
  }
  if (isHeavySlamMove(move)) {
    power = calcPowerHeavy({ offencePokemon, deffencePokemon });
  }
  // 可変威力技はUI側で計算済み威力をcustom_powerに入れておく
  if (isOhakamairiMove(move)) {
    power = offencePokemon.other_setting.custom_power || 50;
  }
  if (isHundonokobushiMove(move)) {
    power = offencePokemon.other_setting.custom_power || 50;
  }
  if (isStoredPowerMove(move)) {
    power = offencePokemon.other_setting.custom_power || 20;
  }
  if (isHakidasuMove(move)) {
    power = offencePokemon.other_setting.custom_power || 100;
  }
  if (isWringOutMove(move) && offencePokemon.other_setting.custom_power) {
    power = offencePokemon.other_setting.custom_power;
  }
  // トリプルアクセル/トリプルキックの時、Hit回数によって威力が変わる
  if (isTripleKickAcceleratorMove(move)) {
    power = power * loopHitNumber;
  }

  // テラバーストでステラタイプ選択時は威力100
  if (isTerabrastMove(move) && offencePokemon.terasu_type === 19) {
    power = 100;
  }

  // 威力2倍条件の対象技
  // NOTE: 「たたりめ」「ひゃっきやこう」は対象が状態異常なら自動で2倍になる
  //       「ベノムショック」「どくばりセンボン」は対象がどく状態なら自動で2倍になる
  //       UI側の double_power_condition は「行動順/被弾/HP条件」など自動判定できないもののために残す
  const hasAnyStatusAilment =
    hasPokemonStatus(deffencePokemon.other_setting, 'status-ailment') ||
    isBurnedStatus(deffencePokemon.other_setting) ||
    isPoisonedStatus(deffencePokemon.other_setting) ||
    hasPokemonStatus(deffencePokemon.other_setting, 'paralyzed');
  const hasPoisonedStatus = isPoisonedStatus(deffencePokemon.other_setting);
  const shouldDoublePowerByTargetStatus =
    // たたりめ / ひゃっきやこう
    (move.id === 506 || move.id === 844) ? hasAnyStatusAilment :
    // ベノムショック / どくばりセンボン
    (move.id === 474 || move.id === 839) ? hasPoisonedStatus :
    false;
  const doublePowerCondition =
    Boolean(offencePokemon.other_setting?.double_power_condition) || shouldDoublePowerByTargetStatus;

  if (isDoublePowerMove(move) && doublePowerCondition) {
    power = power * 2;
  }

  // エアロック・ノーてんき特性チェック（天気無効化）
  const weatherBlocked = hasWeatherBlockAbility(offencePokemon) || hasWeatherBlockAbility(deffencePokemon);


  // ウェザーボール使用時の威力変更（天気が発生している場合は威力100）
  if (isWeatherBallMove(move) && !weatherBlocked) {
    if (otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI ||
      otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME ||
      otherSetting.weather === WEATHER_YUKI || otherSetting.weather === WEATHER_SUNA) {
      power = 100;
    }
  }

  // だいちのはどう使用時の威力変更（フィールドが発生している場合は威力100）
  if (isWavesOfTheEarthMove(move)) {
    if (otherSetting.battle_field === BATTLE_FIELD_GLASS || otherSetting.battle_field === BATTLE_FIELD_MISUTO ||
      otherSetting.battle_field === BATTLE_FIELD_PSYCHO_SAIKO || otherSetting.battle_field === BATTLE_FIELD_EREKI) {
      power = 100;
    }
  }

  // オーガポン(お面フォルム)の全技威力1.2倍補正
  if (offencePokemon.id === 10273 || // オーガポン(いどのめん)
    offencePokemon.id === 10274 || // オーガポン(かまどのめん)
    offencePokemon.id === 10275) { // オーガポン(いしずえのめん)
    power = Math.floor(power * per_120);
  }

  // 威力補正は4096基準で積み上げる
  let rate = 4096;

  // ハイドロスチーム使用時の威力変更（晴れ状態の場合は威力1.5倍）
  if (isHydroSteamMove(move) && !weatherBlocked && (otherSetting.weather === WEATHER_HARE || otherSetting.weather === WEATHER_OOHIDERI)) {
    rate = Math.floor(rate * per_150);
  }

  // ソーラービーム・ソーラーブレード使用時の威力変更（雨状態の場合は威力半減）
  if (!weatherBlocked && (otherSetting.weather === WEATHER_AME || otherSetting.weather === WEATHER_OOAME)) {
    if (move.name_ja === 'ソーラービーム' || move.name_ja === 'ソーラーブレード') {
      power = Math.floor(power / 2);
    }
  }

  // フィールド×技
  // エレキフィールド
  if (otherSetting.battle_field === BATTLE_FIELD_EREKI) {
    // サイコブレイドは浮いててもOK
    if (isPsyBladeMove(move)) {
      rate = Math.floor(rate * per_150);
    }
    // ライジングボルトは防御側が接地している必要
    if (isRisingBoltMove(move) && !isNotGrounded(deffencePokemon, false)) {
      rate = Math.floor(rate * per_200);
    }
  }
  // サイコフィールド
  if (otherSetting.battle_field === BATTLE_FIELD_PSYCHO_SAIKO) {
    // ワイドフォースは自分が接地している必要
    if (isWideForceMove(move) && !isNotGrounded(offencePokemon, true)) {
      rate = Math.floor(rate * per_150);
    }
  }
  // ミストフィールド
  if (otherSetting.battle_field === BATTLE_FIELD_MISUTO) {
    // ミストバーストは自分が接地している必要
    if (move.name_ja === 'ミストバースト' && !isNotGrounded(offencePokemon, true)) {
      rate = Math.floor(rate * per_150);
    }
  }

  // 特性
  if (normalSkinConverted) {
    rate = Math.floor(rate * per_120);
  } else if (
    isFailySkin(offencePokemon) &&
    effectiveMove.type === POKEMON_TYPE_NORMAL
  ) {
    rate = Math.floor(rate * per_120);
  } else if (isSkySkin(offencePokemon) && effectiveMove.type === POKEMON_TYPE_FLYING) {
    rate = Math.floor(rate * per_120);
  } else if (isErekiSkin(offencePokemon) && effectiveMove.type === POKEMON_TYPE_ELECTRIC) {
    rate = Math.floor(rate * per_120);
  } else if (isFreezeSkin(offencePokemon) && effectiveMove.type === POKEMON_TYPE_ICE) {
    rate = Math.floor(rate * per_120);
  } else if (isHadouMove(move) && isMegaLauncher(offencePokemon)) {
    rate = Math.floor(rate * per_150);
  } else if (isOtoMove(move) && isPunkRock(offencePokemon)) {
    rate = Math.floor(rate * per_130);
  } else if (
    isKamitukiMove(move) &&
    isGanzixyouago(offencePokemon)
  ) {
    rate = Math.floor(rate * per_150);
  } else if (isSutemiWazaMove(move) && isSutemi(offencePokemon)) {
    rate = Math.floor(rate * per_120);
  } else if (
    isPunchMove(move) &&
    isTetunokobushi(offencePokemon)
  ) {
    rate = Math.floor(rate * per_120);
  } else if (
    isDirectAttackMove(move) &&
    isKataitume(offencePokemon)
  ) {
    rate = Math.floor(rate * per_130);
  } else if (
    isDokubousou(offencePokemon) &&
    isPoisonedStatus(offencePokemon.other_setting) &&
    (isPhysicalMove(move) ||
     photonGeyserUsesAttack)
  ) {
    rate = Math.floor(rate * per_150);
  } else if (
    isNetubousou(offencePokemon) &&
    isBurnedStatus(offencePokemon.other_setting) &&
    (isSpecialMove(move) ||
     photonGeyserUsesSpecial)
  ) {
    rate = Math.floor(rate * per_150);
  } else if (
    isSunanotikara(offencePokemon) &&
    otherSetting.weather === WEATHER_SUNA &&
    (effectiveMove.type === POKEMON_TYPE_ROCK ||
      effectiveMove.type === POKEMON_TYPE_GROUND ||
      effectiveMove.type === POKEMON_TYPE_STEEL)
  ) {
    rate = Math.floor(rate * per_130_normal_jewel_field);
  } else if (
    isTechnician(offencePokemon) &&
    power <= 60
  ) {
    rate = Math.floor(rate * per_150);
  } else if (isAnalyze(offencePokemon)) {
    rate = Math.floor(rate * per_130_normal_jewel_field);
  }

  // ちからずく（追加効果のある技の威力を1.3倍）
  if (
    isTikarazuku(offencePokemon) &&
    isTikarazukuTargetMove(move)
  ) {
    rate = Math.floor(rate * per_130_normal_jewel_field);
  }

  // きれあじの補正（独立して適用）
  if (isKiruMove(move) && isKireazi(offencePokemon)) {
    rate = Math.floor(rate * per_150);
  }

  // アイテム
  if (
    offencePokemon.selected_item_id ===
    OFFENCE_ITEM_ID_PUNCHGLOVE &&
    isPunchMove(move)
  ) {
    rate = Math.floor(rate * per_110_punchglobe);
  } else if (
    offencePokemon.selected_item_id ===
    OFFENCE_ITEM_ID_TIKARANOHACHIMAKI &&
    (isPhysicalMove(move) ||
     photonGeyserUsesAttack)
  ) {
    rate = Math.floor(rate * per_110);
  } else if (
    offencePokemon.selected_item_id ===
    OFFENCE_ITEM_ID_MONOSHIRIMEGANE &&
    (isSpecialMove(move) ||
     photonGeyserUsesSpecial)
  ) {
    rate = Math.floor(rate * per_110);
  } else if (
    offencePokemon.selected_item_id ===
    OFFENCE_ITEM_ID_NORMAL_JEWEL &&
    effectiveMove.type === POKEMON_TYPE_NORMAL
  ) {
    rate = Math.floor(rate * per_130_normal_jewel_field);
  }

  // 各種プレート (対応するタイプの技を1.2倍)
  if (isPlateItem(offencePokemon.selected_item_id)) {
    const plateType = getPlateType(offencePokemon.selected_item_id);
    if (plateType === effectiveMove.type) {
      rate = Math.floor(rate * per_120);
    }
  }

  // しらたま (パルキア専用、ドラゴン・みずタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_SHIRATAMA &&
    offencePokemon.id === 484 && // パルキア
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_WATER)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // こんごうだま (ディアルガ専用、ドラゴン・はがねタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_KONGOUDAMA &&
    offencePokemon.id === 483 && // ディアルガ
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_STEEL)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // はっきんだま (ギラティナ専用、ドラゴン・ゴーストタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_HAKKINDAMA &&
    (offencePokemon.id === 487 || offencePokemon.id === 10007) && // ギラティナ（アナザー・オリジン）
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_GHOST)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // こころのしずく (ラティオス・ラティアス専用、ドラゴン・エスパータイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_KOKORONOSHIZUKU &&
    (offencePokemon.id === 380 || offencePokemon.id === 381) && // ラティアス・ラティオス
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_PSYCHIC)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // だいこんごうだま (ディアルガ(オリジンフォルム)専用、ドラゴン・はがねタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_DAIKONGOUDAMA &&
    offencePokemon.id === 10245 && // ディアルガ(オリジンフォルム)
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_STEEL)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // だいしらたま (パルキア(オリジンフォルム)専用、ドラゴン・みずタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_DAISHIRATAMA &&
    offencePokemon.id === 10246 && // パルキア(オリジンフォルム)
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_WATER)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // だいはっきんだま (ギラティナ(オリジンフォルム)専用、ドラゴン・ゴーストタイプ技を1.2倍)
  if (
    offencePokemon.selected_item_id === OFFENCE_ITEM_ID_DAIHAKKINDAMA &&
    offencePokemon.id === 10007 && // ギラティナ(オリジンフォルム)
    (effectiveMove.type === POKEMON_TYPE_DRAGON || effectiveMove.type === POKEMON_TYPE_GHOST)
  ) {
    rate = Math.floor(rate * per_120);
  }

  // 状態異常による威力補正
  // からげんき + やけど・どく状態
  if (
    isKaragenkiMove(move) &&
    (isBurnedStatus(offencePokemon.other_setting) || isPoisonedStatus(offencePokemon.other_setting))
  ) {
    rate = Math.floor(rate * per_200);
  }

  // じゅうでん + でんきタイプ技
  if (isJuudenStatus(offencePokemon.other_setting) && effectiveMove.type === POKEMON_TYPE_ELECTRIC) {
    rate = Math.floor(rate * per_200);
  }

  // はたきおとす + 防御側が道具を所持
  if (
    isHatakiotosuMove(move) &&
    deffencePokemon.selected_item_id !== undefined &&
    deffencePokemon.selected_item_id !== DEFENCE_ITEM_ID_NO_SET
  ) {
    rate = Math.floor(rate * per_150);
  }

  // フィールド効果（接地時）
  if (!isNotGrounded(offencePokemon, true)) {
    // サイコフィールド + エスパータイプ技
    if (
      otherSetting.battle_field === BATTLE_FIELD_PSYCHO_SAIKO &&
      effectiveMove.type === POKEMON_TYPE_PSYCHIC
    ) {
      rate = Math.floor(rate * per_130_normal_jewel_field);
    }
    // グラスフィールド + くさタイプ技
    else if (
      otherSetting.battle_field === BATTLE_FIELD_GLASS &&
      effectiveMove.type === POKEMON_TYPE_GRASS
    ) {
      rate = Math.floor(rate * per_130_normal_jewel_field);
    }
    // エレキフィールド + でんきタイプ技
    else if (
      otherSetting.battle_field === BATTLE_FIELD_EREKI &&
      effectiveMove.type === POKEMON_TYPE_ELECTRIC
    ) {
      rate = Math.floor(rate * per_130_normal_jewel_field);
    }
  }

  // ミストフィールド + ドラゴンタイプ技（威力半減）
  // 地面にいる防御側のポケモンのみ影響を受ける
  if (
    otherSetting.battle_field === BATTLE_FIELD_MISUTO &&
    effectiveMove.type === POKEMON_TYPE_DRAGON &&
    !isNotGrounded(deffencePokemon, false)
  ) {
    rate = Math.floor(rate * per_050);
  }

  // グラスフィールド + じしん・じならし時の威力減衰
  if (
    otherSetting.battle_field === BATTLE_FIELD_GLASS &&
    (isZishinMove(move) || move.id === 523) // じしん、じならし
  ) {
    rate = Math.floor(rate * per_050);
  }

  let finalPower = calc_五捨五超入_gosutegoire((power * rate) / 4096);
  if (finalPower < 1) {
    finalPower = 1;
  }

  // テラスタル一致時に威力60未満を底上げする特例（テラバースト以外の対象技）
  if (isTerasPowerUpMove(move) &&
     offencePokemon.terasu_type &&
    //  offencePokemon.terasu_type === move.type &&
     finalPower < 60) {
    finalPower = 60
  }

  return finalPower;
}

type GyroBallSpeedModifiers = {
  offence?: PowerMoveSpeedModifiers;
  defence?: PowerMoveSpeedModifiers;
};

// ジャイロボールの基礎威力を算出する
function calcPowerGyroBall({
  offencePokemon,
  deffencePokemon,
  otherSetting,
  modifiers,
}: {
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
  otherSetting: otherSetting;
  modifiers?: GyroBallSpeedModifiers;
}): number {
  const selfSpeed = calcEffectiveSpeedForPowerMoves(
    offencePokemon,
    otherSetting,
    modifiers?.offence,
  );
  const opponentSpeed = calcEffectiveSpeedForPowerMoves(
    deffencePokemon,
    otherSetting,
    modifiers?.defence,
  );

  // 第六世代以降の挙動: 自分Sが0以下なら威力1
  if (selfSpeed <= 0) {
    return 1;
  }

  const raw = Math.floor((25 * opponentSpeed) / selfSpeed) + 1;
  return Math.max(1, Math.min(150, raw));
}

// エレキボールの基礎威力を算出する
function calcPowerElectroBall({
  offencePokemon,
  deffencePokemon,
  otherSetting,
  modifiers,
}: {
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
  otherSetting: otherSetting;
  modifiers?: GyroBallSpeedModifiers;
}): number {
  const offenceSpeed = calcEffectiveSpeedForPowerMoves(
    offencePokemon,
    otherSetting,
    modifiers?.offence,
  );
  const defenceSpeed = calcEffectiveSpeedForPowerMoves(
    deffencePokemon,
    otherSetting,
    modifiers?.defence,
  );

  if (defenceSpeed <= 0) {
    return 40;
  }

  const ratio = offenceSpeed / defenceSpeed;
  if (ratio < 1) return 40;
  if (ratio < 2) return 60;
  if (ratio < 3) return 80;
  if (ratio < 4) return 120;
  return 150;
}

/**
 * けたぐり/くさむすびでの威力計算をする
 * @param deffencePokemon 体重計算するべき防御側のポケモン
 * @returns 威力
 */
function calcPowerKetaguri(deffencePokemon: PokemonV2): number {
  const w = deffencePokemon.weight;
  if (w < 100) {
    return 20;
  } else if (w < 250) {
    return 40;
  } else if (w < 500) {
    return 60;
  } else if (w < 1000) {
    return 80;
  } else if (w < 2000) {
    return 100;
  }
  return 120;
}

function calcPowerHeavy({
  offencePokemon,
  deffencePokemon,
}: {
  offencePokemon: PokemonV2;
  deffencePokemon: PokemonV2;
}): number {
  // ヘビーボンバー/ヒートスタンプ用の体重比判定
  const temp = deffencePokemon.weight / offencePokemon.weight;
  if (temp <= 1 / 5) {
    return 120;
  }
  if (temp <= 1 / 4) {
    return 100;
  }
  if (temp <= 1 / 3) {
    return 80;
  }
  if (temp <= 1 / 2) {
    return 60;
  }
  return 40;
}
